import {
    Ota,
    ProductVariant,
    ProductVariantOption,
    ProductVariantRequest,
} from './ota.types';
import {
    CreateProductVariantReq1Dto,
    CreateProductVariantReqDto,
    GetOtaProductVariantsResItem0Dto,
    GetOtaProductVariantsResItem1Dto,
    GetProductsResItem0OptionsItemDto,
    OtaName,
} from '../../generated';

export const otaDtoToOta = (dto: any): Ota => ({
    id: dto.name as OtaName,
    uuid: dto.id,
    name: dto.display_name,
    enabled: false,
});

export const productVariantToProductVariantDto = (
    product: ProductVariantRequest
): CreateProductVariantReqDto | CreateProductVariantReq1Dto => ({
    product_id: product.productId,
    capacity_option_id: product.capacityOptionId,
    product_option_ids: product.productOptionIds,
    active: product.active,
    integrations: product.integration
        ? { items: [product.integration] }
        : undefined,
});

export const variantOptionsDtoToVariantOption = (
    option: GetProductsResItem0OptionsItemDto
): ProductVariantOption => ({
    id: option.id,
    name: option.name,
    type: option.type,
});

export const productVariantDtoToProductVariant = (
    variant: GetOtaProductVariantsResItem0Dto | GetOtaProductVariantsResItem1Dto
): ProductVariant => ({
    id: variant.id,
    productId: variant.product.id,
    productName: variant.product.name,
    productType: variant.product.type,
    capacityId: variant.capacity.id,
    capacityName: variant.capacity.reference.name,
    options: variant.options?.items.map(variantOptionsDtoToVariantOption) || [],
});
